<template>
  <div class="Mpmaterial">
    <div class="grouping-name" >
      <van-button v-for="(item, index) in tabbar"
                  :key="index" :name="index"
                  :class="['terminal-btn', { 'selected': activeKey === index }]"
                  icon="/static/images/etv-folder.png"
                  @click="onChange(index)">
        {{ truncatedName(item.name) }}
      </van-button>
    </div>
    <div class="full-name">
      <span>{{groupingName}}</span>
    </div>
    <div id="materiallists" >
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="materiallist abcds">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('append_field.noMore') "
            @load="onLoad"
        >
          <div class="content">
            <div class="photo" :style="{ height: width + 'px', width: width + 'px' }">
              <input type="file" ref="fileInput" @change="handleFileChange" style="display: none;" />
              <img class="up_loading"
                   src="/static/images/program/updata.png"
                   @click="handleClick"
                   style="width: 100%; height: 100%;" />
            </div>
            <div :key="index"
                 :style="{ height: width + 'px', width: width + 'px' }"
                 class="materia-item"
                 v-for="(item, index) in materialList"
                 @click="prImg(item)">
              <div class="checkbox" @click.stop="getselevt(item.checked, index)">
                <van-checkbox v-model="item.checked"></van-checkbox>
              </div>
              <div style="width: 100%; height: 100%;">
                <img v-if="arrFive.includes(item.suffix.toLowerCase())" src="/static/images/program/pdf.png"
                     style="width: 100%; height: 100%;" />
                <img v-else-if="arrSeven.includes(item.suffix.toLowerCase())" src="/static/images/program/xlsx.png"
                     style="width: 100%; height: 100%;" />
                <img v-else-if="arrSix.includes(item.suffix.toLowerCase())" src="/static/images/program/ppt.png"
                     style="width: 100%; height: 100%;" />
                <img v-else-if="arrOne.includes(item.suffix.toLowerCase())" src="/static/images/program/word.png"
                     style="width: 100%; height: 100%;" />
                <img v-else-if="arrsikesi.includes(item.suffix.toLowerCase())" src="/static/images/program/txt.png"
                     style="width: 100%; height: 100%;" />
                <img v-else-if="arrFour.includes(item.suffix.toLowerCase())"
                     v-lazy="getUrl(item.videoViewUrl ? item.videoViewUrl : item.screenshotUrl)"
                     @error="errImg($event, item)"
                     style="width: 100%; height: 100%;" />
                <img v-else-if="arrTwo.includes(item.suffix.toLowerCase())"
                     v-lazy="getUrl(item.screenshotUrl ? item.screenshotUrl : item.url)"
                     @error="errImg($event, item)"
                     style="width: 100%; height: 100%;" />

                <img v-else-if="arrThree.includes(item.suffix.toLowerCase())" src="/static/images/program/msic.png"
                     style="width: 100%; height: 100%;" />
                <img v-else src="/static/images/icon_loader_failed_braseas.png"
                     style="width: 100%; height: 100%;" />
              </div>
              <div class="audit">
                <span v-if="item.auditState === -1" class="audit0">{{$t('append_field.unreviewed')}}</span>
                <span v-if="item.auditState === 1" class="audit2">{{$t('append_field.violating')}}</span>
                <span v-if="item.auditState === 2" class="audit3">{{$t('append_field.suspectedViolating')}}</span>
                <span v-if="item.convertState === 1" class="audit3">{{ $t('append_field.processing') }}</span>
                <span v-if="item.convertState === 2" class="audit3">{{ $t('append_field.failed') }}</span>
              </div>
              <span class="audit-name">{{ item.name }}</span>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="groupings">
      <div>
        <van-button color="#006EFF" size="small" @click="back">{{ $t('append_field.back')}} </van-button>
        <span style="margin-right: 10px"></span>
        <van-button color="#006EFF" size="small" @click="selectAll">{{ $t('append_field.select_all')}}</van-button>
      </div>

      <van-button color="#FF5700" size="small" @click="deletes">{{$t('append_field.delete')}}</van-button>
    </div>
    <van-dialog v-model="show" :title="$t('append_field.select_group')"
                show-cancel-button
                @confirm="() => onChange(activeKey)"
                @cancel="show===false"
                class="select-groupings">
      <van-radio-group v-model="activeKey" >
        <van-cell-group inset>
          <van-cell
              class="active-key"
              v-for="(item, index) in tabbar"
              clickable
              :key="index"
              icon="/static/images/etv-folder.png"
              :title="item.name"
              @click="activeKey = index"
          >
            <template #right-icon>
              <van-radio
                  :name="index"
                  @click.stop
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
    <van-dialog v-model="show2" :title="$t('append_field.Up')" :show-confirm-button="false">
      <div style="margin: 30px 0px">
        <div class="updata">
          <van-cell :title="$t('append_field.fileName')">
            <div class="updata-item">{{ fileName }}</div>
          </van-cell>
          <van-cell :title="$t('append_field.fileSize')">
            <div class="updata-item">{{ fileSize }}M</div>
          </van-cell>
          <van-cell :title="$t('append_field.uploadProgress')">
          </van-cell>
          <van-cell>
            <div class="updata-item-right">
              <van-progress :percentage="complete" pivot-color="#006EFF" stroke-width="4" style="width: 100%;"></van-progress>
            </div>
          </van-cell>
          <div class="updata-item">
            <label class="updata-item-left"></label>
            <div style="float: right;margin: 10px 16px 0 0">
              <van-button color="#FF5700" size="small" @click="cancel">{{$t('append_field.cancelAllUploads')}}</van-button>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>
    <van-image-preview v-model="imagesshow" :images="images"  >
    </van-image-preview>
    <van-overlay :show="loading_show" @click="loading_show = false">
      <div class="wrapper" @click.stop>
        <van-loading  size="40px" vertical >{{$t('append_field.loadinga')}}</van-loading>
      </div>
    </van-overlay>
    <van-dialog v-model="dialogMaterial" class="bound-material" >
      <div slot="title" style="font-size: 18px">
        {{ $t('append_field.bound_material') }} <span style="margin-left: 20px">{{ gridData.length }}</span>
      </div>
      <van-cell-group class="table-container" >
        <van-cell>
          <div class="cell-content">
            <div class="bound-material-index">{{ $t('append_field.index') }}</div>
            <div class="bound-material-name" >{{ $t('append_field.taskName') }}</div>
          </div>
        </van-cell>
        <van-cell v-for="(item, index) in gridData" :key="index">
          <div class="cell-content">
            <div class="bound-material-index">{{ index + 1 }}</div>
            <div class="bound-material-name">{{ item.name }}</div>
          </div>
        </van-cell>
      </van-cell-group>
      <div style="font-size: 14px; margin: 10px;">PS: {{ $t('append_field.tip_material') }}</div>
    </van-dialog>
    <van-dialog v-model="proyVisible"  class="bound-material" >
      <div slot="title" style="font-size: 18px">
        {{ $t('append_field.boundpo') }} <span style="margin-left: 20px">{{ polist.length }}</span>
      </div>

      <van-cell-group class="table-container">
        <van-cell>
          <div class="cell-content">
            <div class="bound-material-index">{{ $t('append_field.index') }}</div>
            <div class="bound-material-name" >{{ $t('append_field.task_name')  }}</div>
            <div class="bound-material-index" >{{ $t('append_field.source')  }}</div>
          </div>
        </van-cell>
        <van-cell v-for="(item, index) in polist" :key="index">
          <div class="cell-content">
            <div class="bound-material-index">{{ index + 1 }}</div>
            <div class="bound-material-name"  >{{ item.pmName }}</div>
            <div class="bound-material-index"  >{{ item.platform }}</div>
          </div>
        </van-cell>
      </van-cell-group>
      <div style="font-size: 14px; margin: 10px;" >PS: {{ $t('append_field.bind_progron') }}</div>
    </van-dialog>
    <!-- 禁用上传弹窗   -->
    <van-dialog v-model="showUploadFileDialog" :title="$t('append_field.getUploadendTim')">
      <div class="dialog-content">
        <span>{{ uploadFileText }}</span>
        <span>{{ $t('append_field.getUploadstartTime_tip') }}</span>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {Dialog, Toast} from 'vant'
import qs from 'qs'
import axios from "axios"

import {classifyFileTypes, fileTypeList} from "../utils/handleUpload";

import uploadService from "../utils/upload.service";
import {checkFileSize, calculateFileMd5, getImageDimensions, getVideoDimensions} from "../utils";
import {getFileSuffix} from "../utils";
import {environment} from "../assets/js/user_environment";

function parseDateTime(dateTimeStr) {
  return new Date(dateTimeStr);
}


export default {
  name: 'addImages',
  data() {

    return {
      loading_show:false,
      width: 0,
      number: 0,
      selectImg: [],
      materia: [],
      show: false,
      tabbar: [],
      groupingName: '',
      activeKey: 0,
      materialList: [],
      allmaterialList: [],
      index: 0,
      isHasMore: true,
      isLoading: false,
      checked: '',
      id: 1,
      FolderIndex: 0,
      msg: this.$t('append_field.loadingb'),
      imagesshow: false,
      images: [],
      show2: false,
      complete: 0,
      source: null,//取消上传
      fileName: "",
      fileSize: 0,
      files:[],
      currentFileMd5: '', // 当前正在上传文件的 MD5，用于精确取消
      dialogMaterial:false,
      gridData:[],
      proyVisible:false,
      polist:[],
      allowUpload:false,
      showUploadFileDialog:false,
      uploadFileText:'',
      totalNum: 0, // Total number of items from the API
      pageNum: 1, // Current page number
      pageSize: 30, // Number of items per page
      hasMore:'',
      loading: false,
      finished: false,
      refreshing: false,
      fileList: [],
      uploadCancelled: false,// 判断取消上传的标识（包含 MD5 阶段）
      typeUpload:'',
      uploadType:"",//这个是来判断上传方式的，上面那个是返回素材是什么方式上传的，然后来决定要不要拼接  0本地 1 cos 2 oss 3 s3
      taskId:'',
      arrOne: [ '.doc', '.docx','.wps','.wpss','.docm','.dotm','.dot','.dotx','.html'],
      arrTwo: ['.jpg', '.jpeg', '.png', '.gif'],
      arrThree: ['.mid', '.wav', '.mp3', '.wma', '.swf', '.aac', '.flac', '.m4a', '.mp2', '.ogg', ".ape", ".ape"],
      arrFour: ['.flv', '.wmv', '.avi', '.mp4', '.mpg', '.mov', '.tlv', '.mkv', '.ts', '.mpeg'],
      arrFive: ['.pdf'],//one-five用来判断上传文件的格式
      arrSix: ['.ppt', '.pptx','.pot','.potx','.pps','.ppsx','.dps','.dpt','.pptm','.potm','.ppsm','.dpss'],
      arrSeven: ['.xls', '.xlsx'],
      arrsikesi: ['.txt'],//one-five用来判断上传文件的格式
    }
  },
  mounted() {
    document.title = this.$t('append_field.material_management')
    this.width = document.getElementById('materiallists').clientWidth / 4 - 3
    this.getFolder(0)
  
    this.selectImg = []

  },
  methods: {

    errImg(event) {
      event.target.src = '/static/images/icon_loader_failed_braseas.png'; // 设置错误图片
    },
    prImg(data) {
      //判断可预览的文件
      let url = data.screenshotUrl? data.screenshotUrl:data.url
      if([".png", ".jpg", ".jpeg", ".gif"].includes(data.suffix) ){
        if(url.startsWith("http")){
          this.images[0]= data.url
        }else {
          this.images[0] = this.upFileUrl + data.url
        }
        this.imagesshow = true
      }else if(['.mp4'].includes(data.suffix)){
        if(url&&url.startsWith("http")){
          window.open(url, '_blank')
        }else {
          this.imagesshow = true
          this.images[0] =this.upFileUrl + url
        }
      }else {
        Toast(this.$t('append_field.viewError'))
      }

    },
    getselevt(sele, index) {
      this.materialList[index].checked = !sele
      this.$set(this.materialList, index, this.materialList[index])
      if (this.selectImg.includes(this.materialList[index])) {
        let i = this.selectImg.indexOf(this.materialList[index])
        this.selectImg.splice(i, 1)
      } else {
        this.selectImg.push(this.materialList[index])
      }

      this.number = this.selectImg.length
    },
    getFolder(index) {
      this.msg = this.$t('append_field.loadingb')
      const p = new Promise((resolve, reject) => {
        this.$ajax.post('/etv/findAllOrOneFolder.json', qs.stringify({
          mtType: '',
          type: 'select',
          id: '',
        })).then(res => {
          if (res.data.code === 0) {
            localStorage.setItem("lastSize",res.data.data.lastSize)
            resolve(res.data.data)
          } else {
            reject()
          }
        })
      })
      p.then(res => {
        this.tabbar = res.children
        this.groupingName = this.tabbar[index].name
        this.id = this.tabbar[index].mfId
      })
    },
    selectAll(){
      const allChecked = this.materialList.every(item => item.checked)
      this.materialList.forEach((item, index) => {
        item.checked = !allChecked
        this.$set(this.materialList, index, item)
        if (!allChecked && !this.selectImg.includes(item)) {
          this.selectImg.push(item)
        } else if (allChecked && this.selectImg.includes(item)) {
          let i = this.selectImg.indexOf(item)
          this.selectImg.splice(i, 1)
        }
      });
      this.number = this.selectImg.length
    },
    async deletes() {
      //把vuex里全选出来的数据存到this.clids和this.types，由于他们是应用的是同一个存储空间所以改变一个的值另一个也会改变
      this.clids = this.checkId

      let deleteObj = []

      if (this.selectImg.length < 1) {
        Toast(this.$t('append_field.selectMaterial'))
        return
      }

      for (let i = 0; i < this.selectImg.length; i++) {
        let obj = {}
        obj= this.selectImg[i].mtId
        deleteObj.push(obj)
      }

      //查询素材是否绑定了节目和文件夹是否为空;ps:只能删除空文件夹;
      // eslint-disable-next-line no-unused-vars
      Dialog.confirm({
        title: this.$t('append_field.deleteMaterial'),
        message: this.$t('append_field.confirmDeleteMaterial'),
      }).then(() => {
        this.$ajax.post(`${this.upFileUrl}etv/deleteMtMaterial.json`,qs.stringify({
          mtIds:  deleteObj.join(',')
        })).then(res => {
          if (res.data.code == 0) {
            let data=res.data.data
            if(data.delCount === 0){
              if(deleteObj.length=== 1){
                this.polist = data.respLst[0]?data.respLst[0].pmList:[]
                if (this.polist.length > 0) {
                  this.proyVisible = true
                }else {
                  this.polist = []
                }
              }else {
                if (data.respLst.length> 0) {
                  this.dialogMaterial = true
                  this.gridData =data.respLst
                }
              }

            }else {
              if (data.respLst.length> 0) {
                this.dialogMaterial = true
                this.gridData = data.respLst
              }
              Toast(res.data.msg)
              this.materialList = []
              this.selectImg.length = 0
              this.getFolder(this.activeKey)
              this.pageNum = 1
              this.selectImg = []
              this.onLoad()
            }

          } else {
            this.pageNum = 1
            this.selectImg = []
            Toast(res.data.msg)
          }
        }).catch(err => {
          console.log(err)
        })

      }).catch(() => {

      })
    },//删除文件或者文件夹
    onChange(index) {
      if (this.activeKey !== index) { // 避免不必要的变更
        this.activeKey = index // 更新活动键
      }
      this.index = -1
      this.FolderIndex = index
      this.materialList = []
      this.groupingName = this.tabbar[index].name
      this.id = this.tabbar[index].mfId
      this.pageNum = 1
      this.selectImg = []
      this.onLoad()
      this.finished = false

    },
    truncatedName(fullName) {
      // 纯函数，不修改响应式数据，避免无限循环
      // 截断名称并确保括号内容完整显示
      const namePart = fullName.split(' (')[0]
      const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : ''
      if (namePart.length  <= 4) {
        return fullName
      } else {
        return `${namePart.substring(0, 4)}...${infoPart}`
      }
    },

    // 点击 div 触发的事件
    async handleClick() {
      try {
        const isAllowed = await this.getUploadSet()
        if (isAllowed) {
          this.allowUpload = true
          // 手动触发文件选择对话框,ios需要用setTimeout强制触发
          setTimeout(() => {
            this.$refs.fileInput.click()
          }, 0)
        } else {
          this.allowUpload = false
        }
      } catch (error) {
        Toast(this.$t('append_field.getUploadSet_tip')) // 处理 AJAX 请求失败的情况
        this.allowUpload = false
      }
    },
    // 文件选择变化事件处理
    async handleFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        const lastSize = localStorage.getItem("lastSize") // 获取剩余空间大小
        const fileSizeInMB = file.size / 1024 / 1024 // 计算文件大小（转换为MB）
        // 当私有化部署时，只允许上传pdf、xls、xlsx文件
        if(environment === 'local'){
          const suffix = getFileSuffix(file.name)
          const allowedTypes = ['.pdf', '.xls', '.xlsx']
          const fileType = '.' + suffix.toLowerCase()
          if (!allowedTypes.includes(fileType)) {
            event.target.value = ''
            Toast(this.$t('append_field.unsupportedFormat'))
            return false
          }
        }
         if (!fileTypeList.includes(file.name.split('.').pop().toLowerCase())) {
          Toast(this.$t('append_field.unsupportedFormat'))
           // 清空input值，确保下次选择同一文件时也能触发change事件
           event.target.value = ''
            return false
        }
        if (lastSize < fileSizeInMB) {
          // 如果文件大小超过剩余空间，显示提示信息
          const remainingSpace = lastSize // 剩余空间大小
          const message = this.$t('append_field.last_size') + ' ' + remainingSpace + 'MB' // 构造包含剩余空间大小的消息
          Toast(message, 'fail') // 显示提示
          // 清空input值，确保下次选择同一文件时也能触发change事件
          event.target.value = ''
          return
        }
        if (fileSizeInMB < 38 / 1024 && ["png", "jpg", "jpeg", "gif"].includes(file.name.split('.').pop().toLowerCase())) {
          Toast(this.$t('append_field.file_less_38'))
          // 清空input值，确保下次选择同一文件时也能触发change事件
          event.target.value = ''
          return false
        }
        // 如果是图片，检查尺寸
        if (file.type.startsWith('image/')) {
          const {width, height} = await getImageDimensions(file)
          // 示例：限制最大尺寸为8000x8000

          if (width > 8000 || height > 8000) {
             Toast(this.$t('append_field.img_size'))
            event.target.value = ''
            return false
          }
        }
        if (!checkFileSize(file)) {
          const suffix = getFileSuffix(file.name)
          const type = '.' + suffix.toLowerCase()
          const fileType = classifyFileTypes(type)


          // 定义各类型文件大小限制（单位：字节）
          const sizeLimits = {
            image: 20 * 1024 * 1024,      // 20MB
            video: 4 * 1024 * 1024 * 1024, // 4GB
            audio: 20 * 1024 * 1024,       // 20MB
            doc: 100 * 1024 * 1024         // 100MB
          }
          const sizeLimitMB = fileType === 'video'
              ? '4GB'
              : `${sizeLimits[fileType] / (1024 * 1024)}MB`
          const fileTypeName = {
            image: this.$t('append_field.image'),
            video:  this.$t('append_field.control_video'),
            audio:  this.$t('append_field.audio'),
            doc:  this.$t('append_field.document'),
          }[fileType]
          Toast(`${fileTypeName}${ this.$t('append_field.file_size_exceed_skip')}${sizeLimitMB}`)
          event.target.value = ''
          return false
        }

        this.fileName = ""
        this.fileSize =""
        this.complete = 0
        /*判断是要本地上传方式*/
        this.fileName = file.name
        this.fileSize = (file.size / 1024 / 1024).toFixed(2)
        this.show2 = true
        this.taskId = null // 重置 taskId
        const MD5_PROGRESS_WEIGHT = 20 // MD5计算占整体进度的20%
        const UPLOAD_PROGRESS_WEIGHT = 70 // 实际上传占整体进度的80%
        // 开始前重置取消标记
        this.uploadCancelled = false

        await calculateFileMd5(file, (md5Percent) => {
          // 将MD5进度映射到整体进度的0-20%
          const totalProgress = Math.floor((md5Percent / 100) * MD5_PROGRESS_WEIGHT)
          // 检查对象是否存在
          if (totalProgress) {
            this.complete = totalProgress
          }
        })

        // 如果在计算 MD5 过程中用户点击了“取消上传”，此时直接结束，不再发起真正的上传请求
        if (this.uploadCancelled) {
          this.uploadCancelled = false
          this.show2 = false
          this.complete = 0
          return
        }
        // 记录当前上传文件的 MD5，后续取消时使用
        this.currentFileMd5 = file.fileMd5 || ''
        const result = await uploadService.upload(file, 1,localStorage.getItem('token'), this.uploadType, {
          onProgress: (percent) => {
            const totalProgress = Math.floor(MD5_PROGRESS_WEIGHT + (percent / 100) * UPLOAD_PROGRESS_WEIGHT)
            this.complete = totalProgress
          }
        })
        if (result) {

          const fd = new FormData()
          fd.append("mfId", this.id)
          fd.append("fileId", result.result)
          if (file.type.startsWith('image/')) {
            const {width, height} = await getImageDimensions(file)
            fd.append("width", width)
            fd.append("height", height)
          } else if (file.type.startsWith('video/')) {
            const {width, height, duration} = await getVideoDimensions(file)
            fd.append("width", width)
            fd.append("height", height)
            fd.append("duration", duration ? duration : '')
          }

          let cancelToken = axios.CancelToken
          this.source = cancelToken.source()
          // 统一返回建议包含 fileId/url；此处沿用原有素材登记接口
          await this.$ajax({
            url: this.upFileUrl + "etv/uploadMaterial.json",
            method: "post",
            cancelToken: this.source.token,
            data: fd,


          }).then(res => {
            this.complete = 100
            event.target.value = ''
            if (res.data.code === 0) {
              this.$nextTick( ()=>{
                this.handleUploadSuccess(res.data.msg)
              })
            } else {
              console.error('COS上传失败:', res.data.msg)
              this.handleUploadError()
            }
          }).catch(() => {

            file.state = -1
            this.handleUploadError()
            // 继续上传下一个文件

          })
        } else {
          file.state = -1 // 失败
          this.handleUploadError()

        }

      }
    },


    handleUploadSuccess(msg){
      this.materialList = []
      this.pageNum = 1
      this.selectImg = []

      this.show2 = false
      this.complete = 0
      this.taskId = null
      Toast(msg)
      this.loading_show = true
      this.getFolder(this.FolderIndex)
      setTimeout(() => {
        this.loading_show = false
        this.onLoad()
      }, 2000);
    },
    handleUploadError() {
      // 关闭上传弹窗
      //this.show2 = false
      // 重置上传状态
      this.complete = 0
      this.taskId = null

      // 显示错误信息（已经在工具函数中显示了Toast）
    },
    // 文件上传处理
    uploadFile(file) {

      setTimeout(() => {
        // 支持上传的格式
      if (fileTypeList.includes(file.name.split('.').pop().toLowerCase())) {
          this.show2 = true
          this.complete = 0
          const formData = new FormData()

          this.fileName = file.name
          this.fileSize = (file.size / 1024 / 1024).toFixed(2)

          let cancelToken = axios.CancelToken // Axios使我修改axios原型链了。
          this.source = cancelToken.source()
          let url
          if(this.uploadType === 0){
            url = this.upFileUrl + 'etv/insertMaterial.json'
            formData.append('files', file)
            formData.append('id', this.id)
          }else {
            url = this.upFileUrl + "etv/uploadMaterial.json"
            formData.append('file', file)
            formData.append('mfId', this.id)
          }

          this.$ajax.post(url, formData, {
            headers: {
              'contentType': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
              const complete = (progressEvent.loaded / progressEvent.total * 100 | 0);
              this.complete = complete
            },
            cancelToken: this.source.token,
          }).then(res => {
            if (res.data.code === 0) {
              this.handleUploadSuccess(res.data.msg)
            } else {
              this.show2 = false
              Toast(res.data.msg)
            }
          }).catch(() => {

            Toast('上传失败')
          })
        } else {

          Toast(this.$t('append_field.unsupportedFormat'))
        }
      }, 300)
    },
    // 判断是否在禁用上传素材时间
    getUploadSet() {
      return new Promise((resolve, reject) => {
        this.$ajax.post('/etv/getUploadSet.json').then(res => {
          if (res.data.code === 0) {
            this.uploadType = res.data.data.uploadType //获取上传类型 上传类型 0-本地 1-cos上传*/
            const currentTime = new Date() // 获取当前时间
            const startTime = parseDateTime(res.data.data.startTime) // 解析接口返回的开始时间
            const endTime = parseDateTime(res.data.data.endTime) // 解析接口返回的结束时间
            const formattedStartTime = startTime.toLocaleString()// 格式化开始时间
            const formattedEndTime = endTime.toLocaleString() // 格式化结束时间
            // 检查当前时间是否在禁止上传的时间段内
            if (currentTime >= startTime && currentTime <= endTime) {
              this.showUploadFileDialog=true
              this.uploadFileText=`${formattedStartTime}—${formattedEndTime}`
              resolve(false) // 不允许上传
            } else {
              resolve(true) // 允许上传
            }
          } else {
            Toast(this.$t('append_field.getUploadSet_tip'))
            resolve(false) // 出现错误，不允许上传
          }
        }).catch(error => {
          Toast(this.$t('append_field.getUploadSet_tip'))
          reject(error) // AJAX 请求失败，传递错误
        })
      })
    },
    async cancel() {
      // 取消当前上传（支持本地直传 / COS / OSS / S3）
      try {
        // 标记为已取消，供 MD5 阶段以及后续逻辑判断
        this.uploadCancelled = true

        // 优先按文件 MD5 精确取消，内部会根据不同 uploadType 做对应处理
        if (this.currentFileMd5) {
          await uploadService.cancelUpload(this.currentFileMd5)
        } else {
          // 兜底：如果还没算出 MD5，就取消所有控制器
          uploadService.cancelAll()
        }

        // 取消 axios 请求（如果有）
        if (this.source) {
          this.source.cancel(this.$t('material.cancelUpload'))
        }

      } catch (error) {
        console.error('取消上传失败:', error)

      }
      // 重置状态
      this.taskId = null
      this.complete = 0
      this.show2 = false
      Toast(this.$t('append_field.cancelAllUploads'))
    },
    back() {
      this.$router.push({path: '/my'})
    },
    getUrl(url) {
      if (!url) {
        return '/static/images/icon_loader_failed_braseas.png'
      }
      const isHttpUrl = url.startsWith("http")


      if (isHttpUrl) {
        // 如果是 HTTP URL 且不是 MP4 文件，直接返回 URL
        return url

      }

      // 如果不是 HTTP URL，拼接基础 URL 并返回
      return this.upFileUrl + url
    },
    onLoad() {
      if (this.materialList.length >= this.totalNum && this.pageNum !== 1) {
        this.finished = true
        this.loading = false
        return
      }
      this.loading = true
      this.getmaterial(this.id, this.pageNum)
    },
    onRefresh() {
      this.finished = false;
      this.pageNum = 1;
      this.materialList = [];
      this.selectImg = []
      this.onLoad()
    },
    getmaterial(id, pageNum) {
      this.$ajax.post('/etv/findAllMaterial.json', qs.stringify({
        id,
        type: '',
        pageNum,
        pageSize: this.pageSize,
        filterType: 0
      })).then(res => {

        if (res.data.code === 0) {
          const newItems = res.data.data.materialList;
          this.totalNum = res.data.data.totalNum; // Update total number of items
          newItems.forEach(res => {
            res.checked = false;
          });
          this.materialList = [...this.materialList, ...newItems];
          this.loading = false;
          this.refreshing = false;

          if (this.materialList.length >= this.totalNum) {
            this.finished = true;
          } else {
            this.pageNum++;
          }
        } else {
          this.loading = false;
          this.refreshing = false;

        }
      }).catch(() => {
        this.loading = false;
        this.refreshing = false;

      });
    },
  },
  destroyed() {
    this.materialList = []

  }
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.Mpmaterial {
  height: 100% !important;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 55;
  background: #ffffff;
  .grouping-name {
    display: flex;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 60px;
    gap: 10px; /* 按钮之间的间隔 */
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid $uni-border-bottom-color;
    overflow-x: auto; /* 水平滚动 */

    .terminal-btn {
      flex: 1 1 auto; /* 自适应宽度 */
      white-space: nowrap; /* 防止文字换行 */
      background-color: white;
      color: black;
      border: 1px solid #ddd; /* 可选：添加边框以便更清晰地看到按钮 */
    }

    .van-button {
      width: 200px !important;
      position: relative;
    }

    .van-button__text {
      display: block;
      width: 100%; /* 使文本占满按钮宽度 */
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    }

    .selected {
      background-color: #006EFF;
      color: white;
    }
  }
  .full-name{
    margin: 0 10px;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    height: 30px;
    line-height: 30px;
    span{
      width: 100%;
      display: block;
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
      font-size: 14px;
      color: #333;
    }
  }
  .van-overlay{
    z-index: 99;
  }
  .materiallist {
    //height: 100%;
    width: 100%;
    padding: 2px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 90px;
    bottom: 60px;
    overflow: auto;
    .content {
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: flex-start;

    }
    .photo {
      box-sizing: border-box;
      padding: 2px;
      margin-top: 8px;
      .van-uploader {
        width: 100%;
        height: 100%;
        border: none;
        display: flex;
        justify-content: center;
        .van-uploader__wrapper {
          width: inherit;
          height: inherit;

          .van-uploader__upload {
            width: inherit;
            height: inherit;
            margin: 0 !important;
            border: none;
          }
        }
      }

      .updata-centnt {
        width: 100%;
        height: 100%;
        border-radius: 5px;

        .updata {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          background: #ffffff;

          .updata-img {
            width: 40%;
            height: 40%;
            margin-bottom: 10px;
          }
        }
      }

    }


    .materia-item {
      position: relative;
      margin: 12px 1px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      .checkbox {
        z-index: 2;
        position: absolute;
        top: 1px;
        right: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;

        checkbox {
          width: 25.42px;
          height: 25.42px;
        }
      }

      .image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .groupings {
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    height: 60px;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
    border-top: 1px solid $uni-border-bottom-color;

  }
  .select-groupings{
    height: calc(100% - 380px);
  }
  .van-dialog__content{
    height: calc(100% - 40px - 60px);
    overflow-y: auto;
  }
  .dialog-content {
    margin: 45px 16px;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    white-space: normal;
    overflow-wrap: break-word;
  }
  .dialog-content span {
    margin-bottom: 8px;
    word-break: break-word;
  }
  .van-cell__title{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .van-icon{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .van-sidebar {
    width: 100%;
    overflow-y: auto; /* 允许垂直方向滚动 */
    height: 100%; /* 高度设置为100%，或者一个固定的值 */
  }
  .bound-material {
    .table-container {
      height:200px;
      overflow-y: auto;
      [class*=van-hairline]::after{
        border: none;
      }

    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
      border-width: 0;
    }
    .cell-content {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .bound-material-index {
      flex: 0 0 20%;
      text-align: center;

    }

    .bound-material-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

  }


}

.updata {
  //background: #ffffff;
  //width: 90%;
  //border-radius: 5px;
  //padding: 20px;
  //box-sizing: border-box;

  .updata-title {
    height: 25px;
    margin-bottom: 10px;
    font-weight: 700;
  }

  .updata-item {
    display: block;
    width: 100%; /* 使文本占满按钮宽度 */
    white-space: nowrap; /* 确保文本在一行显示 */
    overflow: hidden; /* 超出容器部分隐藏 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */

  }
  .updata-item-right {
    height: 20px;
    display: flex;
    align-items: center;
    color: #8c8c8c;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.auditContent {
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.audit-name {
  display: inline-block;
  white-space: nowrap; /* 确保文本在一行显示 */
  overflow: hidden; /* 超出容器部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
  width: 100%;
  line-height: 22px; /* 设置与高度相同的行高 */
  font-size: 15px;
  color: #131212;
}

.audit{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  font-size:  15px;
  white-space: nowrap;
  color: #ffffff;
  .audit0,
  .audit1{
    @extend .auditContent;
    background: rgba(0, 160, 233, 0.61);
  }
  .audit2{
    @extend .auditContent;
    background: rgba(241, 55, 61, 0.79);
  }
  .audit3{
    @extend .auditContent;
    background: rgba(241, 55, 61, 0.79);
  }

}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
